import React, { Fragment, useState } from 'react'
import { withRouter } from 'react-router-dom'
import estilos from '../Zonas/ZonasListComponent.module.css'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { getUnidadesAlmacen, getUnidadesEnvasado, getUnidadesProduccion, getUbicacionByLocalidadAndSublocalidad, getUbicacionBySublocalidad } from "../../../redux/DucksUnidadInspeccion/UnidadesDuck";
import MapaInstalacionesComponent from './MapaInstalacionesComponent';
import InstalacionItemComponent from './InstalacionItemComponent'


function InstalacionesComponent(props) {

    const zona = props.zona
    const localidad = props.localidad
    const sublocalidad = props.sublocalidad

    const unidadesAlmacen = useSelector(store => store.Unidades.unidadesAlmacen)
    const unidadesEnvasado = useSelector(store => store.Unidades.unidadesEnvasado)
    const unidadesProduccion = useSelector(store => store.Unidades.unidadesProduccion)

    const ubicaciones = useSelector(store => store.Unidades.ubicaciones)

    const [mostrarAlmacen, setMostrarAlmacen] = React.useState(true)
    const [mostrarEnvasado, setMostrarEnvasado] = React.useState(false)
    const [mostrarProduccion, setMostrarProduccion] = React.useState(false)

    //RELLENABLES
    const [ubicacionesAlmacen, setUbicacionesAlmacen] = React.useState([])
    const [ubicacionesEnvasado, setUbicacionesEnvasado] = React.useState([])
    const [ubicacionesProduccion, setUbicacionesProduccion] = React.useState([])


    const unidades = [...unidadesAlmacen, ...unidadesEnvasado, ...unidadesProduccion]


    const dispatch = useDispatch()


    //REALIZAR LA CONSULTA DE LAS INSTALACIONES DE LA SUBLOCALIDAD

    React.useEffect(() => {
        dispatch(getUnidadesAlmacen())
        dispatch(getUnidadesEnvasado())
        dispatch(getUnidadesProduccion())


    }, [dispatch]);

    React.useEffect(() => {
        dispatch(getUbicacionByLocalidadAndSublocalidad({ idlocalidad: localidad.idlocalidad, idsublocalidad: sublocalidad.idsublocalidad }))
    }, [dispatch]);

    const handleMostrarUnidadDeProduccion = () => {
        setMostrarAlmacen(false)
        setMostrarEnvasado(false)
        setMostrarProduccion(true)

        let arraxAux = ubicacionesProduccion
        ubicaciones.map((ubicacion, index) => (
            arraxAux = [...ubicacion.unidadproduccionubicacion]
        ))
        setUbicacionesProduccion(arraxAux)
        setUbicacionesEnvasado([])
        setUbicacionesAlmacen([])
    }


    const handleMostrarUnidadDeAlmacen = () => {
        setMostrarAlmacen(true)
        setMostrarEnvasado(false)
        setMostrarProduccion(false)
       let arraxAux = ubicacionesAlmacen
        ubicaciones.map((ubicacion, index) => (
            arraxAux = [...ubicacion.unidadalmacenubicacion]
        ))
        setUbicacionesAlmacen(arraxAux)
        setUbicacionesEnvasado([])
        setUbicacionesProduccion([])
    }


    const handleMostrarUnidadDeEnvasado = () => {
        setMostrarAlmacen(false)
        setMostrarEnvasado(true)
        setMostrarProduccion(false)
        let arraxAux = ubicacionesEnvasado
        ubicaciones.map((ubicacion, index) => (
            arraxAux = [...ubicacion.unidadenvasadoubicacion]
        ))

        setUbicacionesEnvasado(arraxAux)
        setUbicacionesProduccion([])
        setUbicacionesAlmacen([])
    }

    return (
        <Fragment><br />
            <div className={`col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center mt-2`}>
                <h2 className={`${estilos.tituloForm}`}>Lista de Instalaciones de: <strong> ({sublocalidad.nombresublocalidad}, {localidad.nombrelocalidad}), {zona.nombrezona}) </strong></h2>
                <br />
                
                <div className='row'>
                    <div className='col-4'>
                        <button onClick={handleMostrarUnidadDeProduccion} className='btn btn-success'>Unidad de Producción</button>
                    </div>
                    <div className='col-4'>
                        <button onClick={handleMostrarUnidadDeAlmacen} className='btn btn-success'>Unidad de Almacén</button>
                    </div>
                    <div className='col-4'>
                        <button onClick={handleMostrarUnidadDeEnvasado} className='btn btn-success'>Unidad de Envasado</button>
                    </div>
                </div>
                <hr />
                <div className='row' >
                    {
                        mostrarAlmacen ? (
                            <Fragment>
                                <div className='col-8' style={{ textAlign: 'left' }}>
                                    <div style={{ height: '100vh', width: '100%' }}>
                                        <MapaInstalacionesComponent puntos={ubicacionesAlmacen} lat={localidad.lat} lng={localidad.lng} zoom={8}></MapaInstalacionesComponent>
                                    </div>
                                </div>
                                <div className='col-4 mt-3' style={{ textAlign: 'center' }} >
                                    <h4>Unidad de Almacen</h4>
                                    {
                                        ubicacionesAlmacen.map((unidad, index) => (
                                            <InstalacionItemComponent unidad={unidad}
                                                key={index}

                                            ></InstalacionItemComponent>
                                        ))
                                    }
                                </div>
                            </Fragment>
                        ) :
                            mostrarEnvasado ? (
                                <Fragment>
                                    <div className='col-8' style={{ textAlign: 'left' }}>
                                        <div style={{ height: '100vh', width: '100%' }}>
                                            <MapaInstalacionesComponent puntos={ubicacionesEnvasado} lat={localidad.lat} lng={localidad.lng} zoom={8}></MapaInstalacionesComponent>
                                        </div>
                                    </div>
                                    <div className='col-4 mt-3' style={{ textAlign: 'center' }} >
                                        <h4>Unidad de Envasado</h4>

                                        {
                                            ubicacionesEnvasado.map((unidad, index) => (
                                                <InstalacionItemComponent unidad={unidad}
                                                    key={index}

                                                ></InstalacionItemComponent>
                                            ))
                                        }
                                    </div>
                                </Fragment>
                            ) :
                                mostrarProduccion ? (
                                    <Fragment>
                                        <div className='col-8' style={{ textAlign: 'left' }}>
                                            <div style={{ height: '100vh', width: '100%' }}>
                                                <MapaInstalacionesComponent puntos={ubicacionesProduccion} lat={localidad.lat} lng={localidad.lng} zoom={8}></MapaInstalacionesComponent>
                                            </div>
                                        </div>
                                        <div className='col-4 mt-3' style={{ textAlign: 'center' }} >
                                            <h4>Unidad de Producción</h4>

                                            {
                                                ubicacionesProduccion.map((unidad, index) => (
                                                    <InstalacionItemComponent unidad={unidad}
                                                        key={index}

                                                    ></InstalacionItemComponent>
                                                ))
                                            }
                                        </div>
                                    </Fragment>
                                ) :
                                    (<></>)
                    }

                </div>
            </div>
        </Fragment>
    );
};


export default withRouter(InstalacionesComponent)
